import React from "react";
import ReadOnlyInput from "./ReadOnlyInput";
import InputWrapper from "./InputWrapper";
import { InputAdornment, TextField } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { Controller } from "react-hook-form";
import { DEFAULT_SIZE } from "../../../utils/constant";
import ReactInputMask from "react-input-mask";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

export default function ProSsnField({
  name,
  mode,
  label,
  rules,
  control,
  isAddMode,
  fieldProps = {},
  size = DEFAULT_SIZE,
  startAdornment = null,
  ...rest
}) {
  const { t } = useTranslation();
  const { canView = true, canAdd = true, canEdit = true } = rest.permission || {};
  if (!canView || (isAddMode && !canAdd)) return null;
  const editModeAllowed = isAddMode ? canAdd : canEdit;
  if (mode === "read" || (mode === "edit" && !editModeAllowed))
    return <ReadOnlyInput name={name} label={t(label)} size={size} {...rest} rules={rules} />;
  return (
    <InputWrapper size={size}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
          <ReactInputMask mask="999-99-9999" maskChar="" formatChars={{ "9": "[0-9X]" }} value={value} onBlur={onBlur} onChange={onChange}>
            {() => (
              <TextField
                variant="outlined"
                fullWidth
                label={
                  <span>
                    {t(label)}
                    {rules?.required && <span style={{ color: "red" }}> *</span>}
                  </span>
                }
                placeholder={t(label)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  )
                }}
                InputLabelProps={{ shrink: true }}
                helperText={error?.message || null}
                error={!!error}
                {...fieldProps}
              />
            )}
          </ReactInputMask>
        )}
      />
    </InputWrapper>
  );
}

ProSsnField.propTypes = {
  name: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(["read", "edit"]).isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object.isRequired,
  startAdornment: PropTypes.node,
  control: PropTypes.object.isRequired,
  isAddMode: PropTypes.bool,
  fieldProps: PropTypes.object,
  permission: PropTypes.shape({
    canView: PropTypes.bool,
    canAdd: PropTypes.bool,
    canEdit: PropTypes.bool
  }),
  formValues: PropTypes.object,
  size: PropTypes.string,
  handleReadValueclick: PropTypes.func
};
